<script>
import Endpoints from '../../../components/common/Endpoints';
import Request from '../../../components/common/Request';

export default {
    init: async(payload) => {

        payload.domain = Endpoints.domain;
        payload.filter();
    },
    methods:{
        filter: function(){
            let state = this;
            state.truckers = [];
            setTimeout(async function(){
              let trucks = (await Request.do(state, 'GET', Request.getDefaultHeader(state),state.filters,`${Endpoints.trucks.filter}`));
                if (trucks.status==200){
                    state.truckers = trucks.data.results;
                }
        }, 100);
        },
    }
 
}
</script>
